module.exports = __webpack_public_path__ + "static/media/60-points.618f5bd4.png";